'use strict';

import { THEME_TYPES } from '@infoods/lifebase-ui';
import { getLoginRequiredResolveObj } from '../shared/utils/angularUtils';

export const reportsModule = angular
  .module('app.customerManagement', [])
  .config(reportsConfig);

reportsConfig.$inject = ['$routeProvider'];


function reportsConfig($routeProvider) {
  $routeProvider
    .when('/customer-self-setup', {
      template: '<ngz-customer-self-setup></ngz-customer-self-setup>',
      pageConfig: {
        theme: THEME_TYPES.NUTRITION,
        hideNavBar: true,
        hideFooter: true,
      },
    })
    .when('/customer-self-setup/to-entity', {
      template: '<ngz-customer-self-setup-to-entity></ngz-customer-self-setup-to-entity>',
      pageConfig: {
        theme: THEME_TYPES.NUTRITION,
        hideHeader: true,
      },
    })
    .when('/customer-setup/flow-2024/:id', {
      template: '<ngz-customer-setup-flow-2024></ngz-customer-setup-flow-2024>',
      resolve: getLoginRequiredResolveObj(),
    })
    .when('/user-profile', {
      template: '<ngz-user-profile></ngz-user-profile>',
      resolve: getLoginRequiredResolveObj(),
    })
}
